// extracted by mini-css-extract-plugin
export var tosLink = "_9a-0";